import { CALL_VISIBILITIES, todayInKigali } from "../scholarships/model";
import CallFields from "../calls/CallFields";

// A loan call's details with the loans API's limits, for the create dialog and the Details tab
export default function CallDetailsFields({ field, values, savedYear }) {
  return (
    <CallFields
      field={field}
      savedYear={savedYear}
      visibilities={CALL_VISIBILITIES}
      namePlaceholder="e.g. Abroad loans 2026/27"
      quotaLabel="Number of loans"
      summaryMax={1000}
      descriptionMax={5000}
      opensMin={savedYear ? undefined : todayInKigali()}
      closesMin={values.opensDate || todayInKigali()}
    />
  );
}
